<app-top-banner></app-top-banner>
<section class="yoga format bg img-1 legal" id="legal" style="background: url(assets/images/yoga-img/physio-wallpapers/9.jpg) no-repeat 50% 50px fixed; -webkit-background-size: cover !important;">
  <div class="row">
    <div class="col-12 text-left">
      <app-back-arrow></app-back-arrow>
    </div>
  </div>
  <div class="container">
      <div class="row">
          <div class="col-md-8 offset-md-2">
              <div class="title title2">
                  <h2 class="">Legal Documents</h2>
                  <!-- <img src="assets/images/yoga-img/logo/wave-blue.png" alt="" class="img-fluid"> -->
              </div>
          </div>
          <div class="col-md-12 experience-container" >
            <div class="w-100" >
              <div class="row text-center" >
                <div class="col-lg-2 col-md-4">
                  <button class="document-button"
                  style="background: url('assets/images/folder.png'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;"
                  (click)="showAllPAIA()">
                 </button>
                 <div>
                   Show all POPI documents
                 </div>
                </div>
                <div *ngIf="showAllPAIADocuments" class="col-lg-2 col-md-4">
                  <button class="legal-document-button"
                   style="background: url('assets/images/pdf-img.png'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;"
                   (click)="showPAIA()">
                  </button>
                  <div>
                    PAIA manual
                  </div>
                </div>
                <div *ngIf="showAllPAIADocuments" class="col-lg-2 col-md-4">
                  <button class="legal-document-button"
                   style="background: url('assets/images/pdf-img.png'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;"
                   (click)="showRequestAndFeesPayable()">
                  </button>
                  <div>
                    Outcome of request and fees payable
                  </div>
                </div>
                <div *ngIf="showAllPAIADocuments" class="col-lg-2 col-md-4">
                  <button class="legal-document-button"
                   style="background: url('assets/images/pdf-img.png'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;"
                   (click)="showRequestAndFeesPayable()">
                  </button>
                  <div>
                    Request for access to record
                  </div>
                </div>
                <div *ngIf="showAllPAIADocuments" class="col-lg-2 col-md-4">
                  <button class="legal-document-button"
                   style="background: url('assets/images/pdf-img.png'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;"
                   (click)="showRequestGuideCopy()">
                  </button>
                  <div>
                    Request for copy of guide
                  </div>
                </div>
                <div *ngIf="showAllPAIADocuments" class="col-lg-2 col-md-4">

                </div>
                <div class="col-lg-2 col-md-4">
                  <button class="legal-document-button"
                  style="background: url('assets/images/pdf-img.png'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;"
                  (click)="showPracticePolicy()">
                  </button>
                  <div>
                    Practice policy
                  </div>
                </div>
                <div class="col-lg-2 col-md-4">
                  <button class="legal-document-button"
                  style="background: url('assets/images/pdf-img.png'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;"
                  (click)="showPracticePrivacy()">
                  </button>
                  <div>
                    Practice privacy statement
                  </div>
                </div>
                <div class="col-lg-2 col-md-4">
                  <button class="legal-document-button"
                  style="background: url('assets/images/pdf-img.png'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;"
                  (click)="showRequestFormForAccess()">
                  </button>
                  <div>
                    Request form for access to PAIA manual
                  </div>
                </div>
                <div class="col-lg-2 col-md-4">
                  <button class="legal-document-button"
                  style="background: url('assets/images/pdf-img.png'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;"
                  (click)="showWebsite()">
                  </button>
                  <div>
                    Website T&C's
                  </div>
                </div>
              </div>

            </div>
          </div>

      </div>
  </div>
</section>

<app-footer [displayScrollToTop]="false"></app-footer>
